import React from 'react';

import * as FavouriteState from 'constants/FavouriteState';
import * as DisplayMode from 'constants/DisplayMode';

export default class Match extends React.Component {
    static propTypes = {
        match: React.PropTypes.object,
        scores: React.PropTypes.object,
        displayMode: React.PropTypes.object.isRequired,
        matchStatsElement: React.PropTypes.func.isRequired,
        matchClickCallback: React.PropTypes.func.isRequired,
        matchFavouriteClickCallback: React.PropTypes.func
    };

    constructor(props) {
        super(props);

        this._onFavouriteClick = this._onFavouriteClick.bind(this);
    }

    _onMatchClick(id, e) {
        e.preventDefault();
        this.props.matchClickCallback(id);
    }

    _onFavouriteClick(e) {
        e.preventDefault();
        e.stopPropagation();

        this.props.matchFavouriteClickCallback(this.props.match);
    }

    static renderMatchScores(match, matchScores, props) {
        const matchStatsProps = {
            match,
            matchScores,
            mainScoreElement: props.mainScoreElement,
            additionalScoresElement: props.additionalScoresElement,
            additionalScoreElement: props.additionalScoreElement
        };

        const MatchStatsElement = props.matchStatsElement;

        return (<MatchStatsElement {...matchStatsProps}/>);
    }

    render() {
        const {match, scores, displayMode} = this.props;

        if (match === undefined) {
            return false;
        }

        const matchId = match.get('id');
        const notice = match.get('notice') || null;

        let name = match.get('name');
        if (notice !== null) {
            name = name + ' (' + notice + ')';
        }

        const isSelected = (displayMode.type === DisplayMode.MATCH && displayMode.id === matchId);
        const cls = 'event' + (isSelected ? ' selected' : '');

        let favouritesCls = 'favourites';

        if (match.get('favouriteState') === FavouriteState.FULL) {
            favouritesCls += ' added';
        }

        const boundMatchClick = this._onMatchClick.bind(this, matchId);

        const matchScores = match.get('scores')
            .map(id => scores.get(id))
            .filter(s => s.get('score1') !== null && s.get('score1') !== undefined &&
                    s.get('score2') !== null && s.get('score2') !== undefined)
            .toMap();

        return (
            <li className={cls} onClick={boundMatchClick}>
                <div className="event-title">
                    <a className="event-name" title={name}>{name}</a>
                    <a href="#" className={favouritesCls} onClick={this._onFavouriteClick}>{'\u00A0'}</a>
                </div>
                {matchScores && matchScores.size > 0 && Match.renderMatchScores(match, matchScores, this.props)}
            </li>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/Match.jsx